module.exports = __webpack_public_path__ + "84d6c804e581f66f0a544a617908fdb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/lyzarsky-vycvik-2.jpg
// module id = 1191
// module chunks = 0